import React from "react";
import HourWeather from "./HourWeather";
import TenDayWeather from "./TenDayWeather/index.tsx";
import { getMainDomain } from "@/utils/getMainDomain";

const WeatherForecast: React.FC<any> = () => {
  const mainDomain = getMainDomain();
  if (mainDomain === "24hweather.com") {
    return (
      <>
        <TenDayWeather />
        <HourWeather />
      </>
    );
  }
  return (
    <>
      <HourWeather />
      <TenDayWeather />
    </>
  );
};

export default WeatherForecast;
